import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carousel-dashboard-placeholder',
  templateUrl: './carousel-dashboard-placeholder.component.html',
  styleUrls: ['./carousel-dashboard-placeholder.component.scss']
})
export class CarouselDashboardPlaceholderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
